var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20842 3.29297H3.64374C2.84564 3.29297 2.19922 3.97839 2.19922 4.82272V12.47C2.19922 13.3151 2.84564 13.9998 3.64374 13.9998H11.5886C12.3867 13.9998 13.0331 13.3151 13.0331 12.47V6.87249L10.2062 9.86554C9.95933 10.1295 9.63783 10.3119 9.28459 10.3885L7.34821 10.7987C6.08426 11.0659 4.97053 9.88648 5.22332 8.54886L5.61045 6.49836C5.68051 6.12856 5.85241 5.78838 6.10448 5.52186L8.20842 3.29297Z",
    fill: "#A9A8B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3675 1.95125C14.2945 1.76637 14.1874 1.59684 14.0519 1.45144C13.9186 1.30925 13.7579 1.1955 13.5795 1.11704C13.4037 1.03985 13.2139 1 13.0219 1C12.83 1 12.6401 1.03985 12.4643 1.11704C12.2859 1.1955 12.1253 1.30925 11.992 1.45144L11.5976 1.86891L13.6575 4.05014L14.0519 3.63195C14.1888 3.48766 14.2961 3.31783 14.3675 3.13214C14.5163 2.75257 14.5163 2.33082 14.3675 1.95125ZM12.637 5.13136L10.5763 2.94941L7.1261 6.60405C7.0752 6.65829 7.04087 6.72595 7.02715 6.79906L6.64002 8.85028C6.58946 9.11751 6.81264 9.35297 7.06471 9.29952L9.00181 8.89C9.0723 8.87429 9.13645 8.83781 9.18599 8.78527L12.637 5.13136Z",
    fill: "#A9A8B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLight);
export default __webpack_public_path__ + "static/media/edit_light.31796fbd9697a3955827c2e6cc763c82.svg";
export { ForwardRef as ReactComponent };